// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"ddbb1740","591":"8b6a8760","691":"8b6a8760","705":"ddbb1740","738":"ddbb1740"}[chunkId] + ".chunk.css";
};